import { ServiceDetailPage } from './ServiceDetailPage';

export function HomelabServices() {
  return <ServiceDetailPage slug="homelab" />;
}
